import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StepStatus } from '../../core/steps.service';
import { UNPAID_TABLE_COLUMNS } from '../../shared/constants/operationals';
import { UtilsService } from '../../core/utils.service';
import { DialogService } from '../../core/dialog.service';
import { ErrorService, SplittypayError } from '../../core/error.service';
import { Unpaid, UnpaidStatus } from '../../core/unpaid.service';
import { UnpaidSetNoteDialogComponent } from '../unpaid-set-note-dialog/unpaid-set-note-dialog.component';

@Component({
  selector: 'app-unpaid-data-table',
  templateUrl: './unpaid-data-table.component.html',
  styleUrls: ['./unpaid-data-table.component.scss'],
})
export class UnpaidDataTableComponent {
  @Input() unpaid: Unpaid[] = [];
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();

  displayed_columns: string[] = UNPAID_TABLE_COLUMNS;
  completed_step_status: StepStatus = StepStatus.completed;

  constructor(
    private utils_service: UtilsService,
    private dialog_service: DialogService,
    private error_service: ErrorService,
  ) {}

  onSetNoteClick(unpaid: Unpaid) {
    this.dialog_service
      .openDialog(UnpaidSetNoteDialogComponent, { unpaid })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }

  getCurrencyLabel(currency: string): string {
    return this.utils_service.getCurrencyLabelFromString(currency);
  }

  getStepStatusClass(status: UnpaidStatus): string {
    return this.utils_service.getUnpaidStatusClass(status);
  }

  getStepStatusLabel(status?: UnpaidStatus): string {
    return this.utils_service.getUnpaidStatusLabel(status);
  }

  daysFromUnpaid(unpaid: Unpaid): number {
    // Calculate the number of days between the creation date and the recovery date
    // If the recovery date is not set, calculate the number of days between the creation date and the current date
    const unpaid_from_date = new Date(unpaid.created_at).getTime();
    const end_date = unpaid.recovered_at ? new Date(unpaid.recovered_at).getTime() : Date.now();
    const difference = end_date - unpaid_from_date;
    return Math.abs(Math.round(difference / (24 * 60 * 60 * 1000)));
  }

  getFullName(unpaid: Unpaid): string {
    return `${unpaid.buyer_firstname} ${unpaid.buyer_lastname}`;
  }
}
